import { menuConstants } from "@constants/menuConstants";

import { useDefaultLandingPageLink } from "@app/hooks";

function useRemoveProjectsNav() {
  const { type } = useDefaultLandingPageLink();

  const filterProjectsNav = (item: { type: string }) => {
    return (
      type === "client" ||
      item.type !== menuConstants.menuItemTypes.NAV_SEARCHABLE_DROPDOWN
    );
  };

  return {
    filterProjectsNav
  };
}

export default useRemoveProjectsNav;
